// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__1jDJg","modal":"Modal_modal__2YZvb","modalClose":"Modal_modalClose__24hVC","modalBody":"Modal_modalBody__1YT3C"};